module.exports = "<app-home></app-home>\n<router-outlet></router-outlet>"